import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100vw;

    // Colors
    --bgColor: ${theme.colors.primary};
    --dotColor: #242046;

    // Dimensions
    --dotSize: 1px;
    --dotSpace: 12px;

    background: var(--light);
    background-size: 12px 12px;
  `}
`

export const Main = styled.section`
  ${({ theme }) => css`
    width: 94vw;
    max-width: 680px;
    padding: clamp(1rem, 2rem, 5vw);
    box-shadow: 0 2.5rem 4rem -3rem rgba(247, 25, 99, 0.1);

    > header {
      width: 100%;

      h1 {
        margin-bottom: 0.125rem;
      }

      div {
        margin-top: 2rem;
        margin-bottom: 2rem;
      }

      > p {
        padding: 0;
        margin: 0;

        border-radius: ${theme.border.radius.large};
        font-size: ${theme.font.sizes.small};
        line-height: 1.25;
      }
    }
  `}
`
